// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__1V0tN","img":"item_img__3-Zya","contentContainer":"item_contentContainer__Ofl3F","title":"item_title__25O9h","price":"item_price__1RSt9"};